// extracted by mini-css-extract-plugin
module.exports = {"companyIcon":"styles_companyIcon__1X6T3"};